/** URL-параметры для статистики Managers / Junior (как у итоговой сводки). */

/** Понедельник текущей недели (локальная полуночь) — как в Overview. */
export function getCurrentWeekStartDate() {
  const today = new Date();
  const day = today.getDay();
  const monday = new Date(today);
  monday.setDate(today.getDate() - (day === 0 ? 6 : day - 1));
  monday.setHours(0, 0, 0, 0);
  return monday;
}

/** YYYY-MM-DD по локальному календарю (без MSK/UTC сдвига — он давал день −1). */
export function weekStartToStr(weekStart) {
  if (!(weekStart instanceof Date) || Number.isNaN(weekStart.getTime())) return '';
  const y = weekStart.getFullYear();
  const m = String(weekStart.getMonth() + 1).padStart(2, '0');
  const d = String(weekStart.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function weekStartFromStr(str) {
  if (!str || !/^\d{4}-\d{2}-\d{2}$/.test(str)) return null;
  const [y, m, d] = str.split('-').map(Number);
  if (!y || !m || !d) return null;
  const date = new Date(y, m - 1, d);
  date.setHours(0, 0, 0, 0);
  const dow = date.getDay(); // 0=вс … 1=пн
  // Воскресенье часто = артефакт старого сдвига «понедельник − 1»
  if (dow === 0) date.setDate(date.getDate() + 1);
  else if (dow !== 1) date.setDate(date.getDate() - (dow - 1));
  return date;
}

export function readStatsSearchParams(searchParams) {
  const week = weekStartFromStr(searchParams.get('week'));
  const moderator = searchParams.get('moderator') || null;
  const mode = searchParams.get('mode') === 'table' ? 'table' : 'list';
  return { weekStart: week, moderatorId: moderator, displayMode: mode };
}

export function buildStatsSearchParams({ weekStartStr, moderatorId, displayMode }) {
  const params = new URLSearchParams();
  if (weekStartStr) params.set('week', weekStartStr);
  if (moderatorId) params.set('moderator', String(moderatorId));
  if (displayMode === 'table') params.set('mode', 'table');
  return params;
}

export function managersStatsPath({ moderatorId, weekStartStr, displayMode } = {}) {
  const qs = buildStatsSearchParams({
    weekStartStr: weekStartStr || undefined,
    moderatorId,
    displayMode,
  }).toString();
  return qs ? `/discordmoderation/statistics?${qs}` : '/discordmoderation/statistics';
}

export function juniorStatsPath({ moderatorId, weekStartStr, displayMode } = {}) {
  const qs = buildStatsSearchParams({
    weekStartStr: weekStartStr || undefined,
    moderatorId,
    displayMode,
  }).toString();
  return qs ? `/discordmoderation/statistics-junior?${qs}` : '/discordmoderation/statistics-junior';
}
